import { allValues, Rights } from '../rights';

export const GLOBAL_ADMIN_RIGHTS = Object.freeze([
  ...allValues(Rights.RESIDENTS),
  ...allValues(Rights.EMPLOYEES),
  ...allValues(Rights.BASE_DATA),
  Rights.CARE.DELETE.key,
  ...allValues(Rights.CARE.EXECUTION),
  Rights.CARE.ABSENCE.key,
  ...allValues(Rights.CARE.ASSESSMENT),
  ...allValues(Rights.CARE.CONSULTATION_FORM),
  ...allValues(Rights.CARE.MOVEMENT_STATUS),
  ...allValues(Rights.CARE.BIOGRAPHY),
  ...allValues(Rights.CARE.DATA_COLLECTION),
  ...allValues(Rights.CARE.DECUBITUS_RISK),
  ...allValues(Rights.CARE.NUTRITION_PROTOCOL),
  ...allValues(Rights.CARE.CASE_DISCUSSION),
  ...allValues(Rights.CARE.INDICATORS),
  ...allValues(Rights.CARE.MEDICATION_ORDER),
  ...allValues(Rights.CARE.MEDICATION),
  ...allValues(Rights.CARE.NURSING_REPORT),
  ...allValues(Rights.LISTS),
  Rights.CARE.CARE_PLAN_SUPERVISOR.key,
  ...allValues(Rights.CARE.CARE_PLAN),
  ...allValues(Rights.CARE.NURSE_VISIT),
  ...allValues(Rights.CARE.CARE_ROUNDS),
  ...allValues(Rights.CARE.PAIN_PROTOCOL),
  ...allValues(Rights.CARE.SOCIAL_CARE),
  Rights.CARE.SOCIAL_CARE_GROUP.key,
  ...allValues(Rights.CARE.FALL_PROTOCOL),
  ...allValues(Rights.CARE.FALL_RISK),
  ...allValues(Rights.CARE.VITAL_INFORMATIONS),
  ...allValues(Rights.CARE.DOCTORS_DIAGNOSIS),
  ...allValues(Rights.CARE.VISIT_SHEET),
  ...allValues(Rights.CARE.VITAL_SIGNS),
  ...allValues(Rights.CARE.WOUND_DOCUMENTATION),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING),
  ...allValues(Rights.GENERAL),
  ...allValues(Rights.ROSTER),
  ...allValues(Rights.GLOBAL_ADMIN),
  Rights.ADMINISTRATORS.ADMINISTRATOR_ONLY.key,
]);
